<template>
  <span class="pm-team" v-if="users && users.length">
    <Avatar v-for="user in users.slice(0, 3)"
            :key="user.id"
            :object="user"
            size="xs"
            v-b-tooltip.hover
            :title="user.name"></Avatar>
    <span class="pm-team__more" v-if="users.length > 3">+{{ users.length - 3 }}</span>
  </span>
  <span class="text-muted" v-else>—</span>
</template>

<script>
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'Team',
    components: {
      Avatar
    },
    props: {
      users: {type: Array, default: function() { return []; }}
    }
  }
</script>
